import { render, staticRenderFns } from "./BaseListReservation.vue?vue&type=template&id=2e54209d&"
import script from "./BaseListReservation.vue?vue&type=script&lang=js&"
export * from "./BaseListReservation.vue?vue&type=script&lang=js&"
import style0 from "./BaseListReservation.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports